<script>
  import { onMount } from 'svelte'
  import { scaleLinear, scaleTime, scaleLog } from 'd3-scale'
  import { extent, max } from 'd3-array'
  import { timeParse, timeFormat } from 'd3-time-format'
  import { line, area } from 'd3-shape'
  import { curveLinear } from 'd3-shape'
  import { format } from 'd3-format'
  let tooltipX = -1000
  let tooltipY = -1000
  let tweetName = '@name'
  let tweetDate = 'Date'
  let tweetContent = 'Content'
  let width = 300
  let height = 300
  let date = '2021-07-08'

  $: dateTime = timeParse('%Y-%m-%d')(date)

  let tweets = []
  async function getTweets() {
    await fetch(
      `https://mediahack.co.za/looting/api/get-tweets-chart.php?limit=100&date=${date}`
    )
      .then((response) => response.json())
      .then((response) => {
        response.forEach((d) => {
          d.datetime = timeParse('%Y-%m-%d %H:%M:%S')(d.datetime)
          d.retweets = +d.retweets
        })
        tweets = response
      })
  }

  onMount(() => {
    getTweets()

    promise = true
  })

  let promise = false
  let margin = {
    top: 20,
    right: 20,
    bottom: 20,
    left: 20,
  }
  let formatDate = timeFormat('%-I%p')
  let formatDateLabel = timeFormat('%e %B %Y')

  $: rScale = scaleLinear()
    .domain([0, max(tweets, (d) => d.retweets)])
    .range([1, 100])

  $: xScale = scaleTime()
    .domain(extent(tweets, (d) => d.datetime))
    .range([margin.left, width - margin.right])

  $: yScale = scaleLinear()
    .domain([0, max(tweets, (d) => +d.retweets)])
    .range([height - margin.bottom, margin.top])

  $: xTicks = xScale.ticks(12)
  $: yTicks = yScale.ticks(5)

  function hover(event, tweet) {
    tweetName = tweet.username
    tweetDate = tweet.datetime
    tweetContent = tweet.tweet
    tooltipX = event.clientX
    tooltipY = event.clientY
  }
  function hoverOut() {
    tooltipX = -1000
    tooltipY = -1000
  }
  let dates = [
    '2021-07-08',
    '2021-07-09',
    '2021-07-10',
    '2021-07-11',
    '2021-07-12',
    '2021-07-13',
    '2021-07-14',
    '2021-07-15',
    '2021-07-16',
  ]
  let int = 0
  let auto = setInterval(() => {
    date = dates[int]
    int++
    if (int > 8) int = 0
    getTweets()
    tweets = tweets
  }, 1500)
  let paused = false
  function pause() {
    if (paused) {
      auto = setInterval(() => {
        date = dates[int]
        int++
        if (int > 8) int = 0
        getTweets()
        tweets = tweets
      }, 1500)
      paused = false
    } else {
      window.clearInterval(auto)
      paused = true
    }
  }
  function switchDate(date) {
    if (paused) {
      getTweets()
      tweets = tweets
      console.log(date)
    }
  }
</script>

<div class="tooltip" style="left:{tooltipX + 5}px; top:{tooltipY + 5}px;">
  <div class="tweet-name">{tweetName}</div>
  <div class="tweet-date">{tweetDate}</div>
  <div class="tweet-content">{tweetContent}</div>
</div>
<div class="line-chart" bind:clientWidth={width} style="height: {height}px;">
  <div class="date-options">
    <div
      class="date-block {date === '2021-07-08' ? 'date-selected' : ''}"
      on:click={() => switchDate('2021-07-08')}
    >
      8 July
    </div>
    <div
      class="date-block {date === '2021-07-09' ? 'date-selected' : ''}"
      on:click={() => switchDate('2021-07-09')}
    >
      9 July
    </div>
    <div
      class="date-block {date === '2021-07-10' ? 'date-selected' : ''}"
      on:click={() => switchDate('2021-07-10')}
    >
      10 July
    </div>
    <div
      class="date-block {date === '2021-07-11' ? 'date-selected' : ''}"
      on:click={() => switchDate('2021-07-11')}
    >
      11 July
    </div>
    <div
      class="date-block {date === '2021-07-12' ? 'date-selected' : ''}"
      on:click={() => switchDate('2021-07-12')}
    >
      12 July
    </div>
    <div
      class="date-block {date === '2021-07-13' ? 'date-selected' : ''}"
      on:click={() => switchDate('2021-07-13')}
    >
      13 July
    </div>
    <div
      class="date-block {date === '2021-07-14' ? 'date-selected' : ''}"
      on:click={() => switchDate('2021-07-14')}
    >
      14 July
    </div>
    <div
      class="date-block {date === '2021-07-15' ? 'date-selected' : ''}"
      on:click={() => switchDate('2021-07-15')}
    >
      15 July
    </div>
    <div
      class="date-block {date === '2021-07-16' ? 'date-selected' : ''}"
      on:click={() => switchDate('2021-07-16')}
    >
      16 July
    </div>
  </div>
  <div class="pause">
    {#if !paused}
      <img src="/images/pause.svg" alt="Pause Button" on:click={pause} /><br />
    {:else}
      <img
        src="/images/playbutton-plain.svg"
        alt="Play Button"
        on:click={pause}
      /><br />
    {/if}
    {#if !paused}
      Click pause to explore the data
    {:else}
      Click to resume
    {/if}
  </div>
  {#if promise}
    <svg {width} {height}>
      <!-- <text x="20" y="20" class="date-label">{formatDateLabel(dateTime)}</text> -->
      {#each xTicks as tick}
        <!-- svelte-ignore component-name-lowercase -->
        <line
          x1={xScale(tick)}
          x2={xScale(tick)}
          y1="0"
          y2={height}
          class="tick"
        />
        <text x={xScale(tick)} y={height - 0} class="tick-label">
          {formatDate(tick)}
        </text>
      {/each}
      <!-- <text x="100" y="100">Text</text> -->
      {#each tweets as tweet}
        <circle
          r={rScale(tweet.retweets)}
          cx={xScale(tweet.datetime)}
          cy={height / 2}
          class="circle"
          on:mousemove={() => hover(event, tweet)}
          on:focus={() => hover(event, tweet)}
          on:mouseout={() => hoverOut()}
          on:blur={() => hoverOut()}
        />
      {/each}
    </svg>
  {/if}
</div>

<style>
  .pause img {
    width: 30px;
    cursor: pointer;
  }
  .date-options {
    width: 70%;
    text-align: center;
    display: grid;
    grid-template-columns: repeat(9, 1fr);
    margin-bottom: 10px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0px;
  }
  .pause {
    margin-bottom: 10px;
    text-transform: uppercase;
    font-size: 0.8rem;
    /* font-weight: 700; */
    min-height: 70px;
  }

  .date-block {
    background: none;
    font-size: 0.9rem;
    padding: 5px;
    font-weight: 700;
  }
  .date-selected {
    background: hotpink;
    color: #000;
  }

  .tooltip {
    position: fixed;
    top: 100px;
    left: 100px;
    background: #1d1d1d;
    color: #fff;
    /* border: solid 1px lightgray; */
    padding: 10px;

    z-index: 100;
    font-size: 0.8rem;
    max-width: 300px;
  }
  .date-label {
    fill: #fff;
    stroke: #000;
    font-family: var(--titleFont);
    font-weight: 700;
    paint-order: stroke;
    stroke-width: 5px;
    stroke: #000;
  }
  .tick-label {
    stroke: rgb(189, 189, 189);
    font-size: 0.8rem;
    text-anchor: middle;
  }
  .tick {
    stroke: rgb(122, 122, 122);
    stroke-dasharray: 2, 2;
  }
  .line-chart {
    position: relative;
    width: 90%;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 100px;
  }
  .circle {
    fill: hotpink;
    stroke: #fff;
    opacity: 0.5;
  }
  .circle:hover {
    fill: #fffb1a;
    opacity: 0.8;
  }
  svg {
    overflow: visible;
  }
</style>
